import { __extends } from "tslib";
import { each, isEqual, isFunction, isNumber, isObject, isArray, noop, mix, upperFirst, uniqueId } from '@antv/util';
import { ext } from '@antv/matrix-util';
import { removeFromArray, isParent } from '../util/util';
import { multiplyMatrix, multiplyVec2, invert } from '../util/matrix';
import Base from './base';
var transform = ext.transform;
var MATRIX = 'matrix';
var CLONE_CFGS = ['zIndex', 'capture', 'visible', 'type'];
// å¯ä»¥å¨ toAttrs ä¸­è®¾ç½®ï¼ä½ä¸å±äºç»å¾å±æ§çå­æ®µ
var RESERVED_PORPS = ['repeat'];
var DELEGATION_SPLIT = ':';
var WILDCARD = '*';
// éè¦èèæ°ç»åµå¥æ°ç»çåºæ¯
// æ°ç»åµå¥å¯¹è±¡çåºæ¯ä¸èè
function _cloneArrayAttr(arr) {
    var result = [];
    for (var i = 0; i < arr.length; i++) {
        if (isArray(arr[i])) {
            result.push([].concat(arr[i]));
        }
        else {
            result.push(arr[i]);
        }
    }
    return result;
}
function getFormatFromAttrs(toAttrs, shape) {
    var fromAttrs = {};
    var attrs = shape.attrs;
    for (var k in toAttrs) {
        fromAttrs[k] = attrs[k];
    }
    return fromAttrs;
}
function getFormatToAttrs(props, shape) {
    var toAttrs = {};
    var attrs = shape.attr();
    each(props, function (v, k) {
        if (RESERVED_PORPS.indexOf(k) === -1 && !isEqual(attrs[k], v)) {
            toAttrs[k] = v;
        }
    });
    return toAttrs;
}
function checkExistedAttrs(animations, animation) {
    if (animation.onFrame) {
        return animations;
    }
    var startTime = animation.startTime, delay = animation.delay, duration = animation.duration;
    var hasOwnProperty = Object.prototype.hasOwnProperty;
    each(animations, function (item) {
        // åä¸ä¸ªå¨ç»å¼å§æ§è¡çæ¶é´ < åä¸ä¸ªå¨ç»çç»ææ¶é´ && åä¸ä¸ªå¨ç»çæ§è¡æ¶é´ > åä¸ä¸ªå¨ç»çå»¶è¿
        if (startTime + delay < item.startTime + item.delay + item.duration && duration > item.delay) {
            each(animation.toAttrs, function (v, k) {
                if (hasOwnProperty.call(item.toAttrs, k)) {
                    delete item.toAttrs[k];
                    delete item.fromAttrs[k];
                }
            });
        }
    });
    return animations;
}
var Element = /** @class */ (function (_super) {
    __extends(Element, _super);
    function Element(cfg) {
        var _this = _super.call(this, cfg) || this;
        /**
         * @protected
         * å¾å½¢å±æ§
         * @type {ShapeAttrs}
         */
        _this.attrs = {};
        var attrs = _this.getDefaultAttrs();
        mix(attrs, cfg.attrs);
        _this.attrs = attrs;
        _this.initAttrs(attrs);
        _this.initAnimate(); // åå§åå¨ç»
        return _this;
    }
    // override
    Element.prototype.getDefaultCfg = function () {
        return {
            visible: true,
            capture: true,
            zIndex: 0,
        };
    };
    /**
     * @protected
     * è·åé»è®¤çå±ç¸
     */
    Element.prototype.getDefaultAttrs = function () {
        return {
            matrix: this.getDefaultMatrix(),
            opacity: 1,
        };
    };
    /**
     * @protected
     * ä¸äºæ¹æ³è°ç¨ä¼å¼èµ·ç»å¸åå
     * @param {ChangeType} changeType æ¹åçç±»å
     */
    Element.prototype.onCanvasChange = function (changeType) { };
    /**
     * @protected
     * åå§åå±æ§ï¼æäºå±æ§éè¦å å·¥
     * @param {object} attrs å±æ§å¼
     */
    Element.prototype.initAttrs = function (attrs) { };
    /**
     * @protected
     * åå§åå¨ç»
     */
    Element.prototype.initAnimate = function () {
        this.set('animable', true);
        this.set('animating', false);
    };
    Element.prototype.isGroup = function () {
        return false;
    };
    Element.prototype.getParent = function () {
        return this.get('parent');
    };
    Element.prototype.getCanvas = function () {
        return this.get('canvas');
    };
    Element.prototype.attr = function () {
        var _a;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var name = args[0], value = args[1];
        if (!name)
            return this.attrs;
        if (isObject(name)) {
            for (var k in name) {
                this.setAttr(k, name[k]);
            }
            this.afterAttrsChange(name);
            return this;
        }
        if (args.length === 2) {
            this.setAttr(name, value);
            this.afterAttrsChange((_a = {},
                _a[name] = value,
                _a));
            return this;
        }
        return this.attrs[name];
    };
    // æ¯å¦è¢«è£åªï¼è¢«è£åªåä¸æ¾ç¤ºï¼ä¸åä¸æ¾å
    Element.prototype.isClipped = function (refX, refY) {
        var clip = this.getClip();
        return clip && !clip.isHit(refX, refY);
    };
    /**
     * åé¨è®¾ç½®å±æ§å¼çæ¥å£
     * @param {string} name å±æ§å
     * @param {any} value å±æ§å¼
     */
    Element.prototype.setAttr = function (name, value) {
        var originValue = this.attrs[name];
        if (originValue !== value) {
            this.attrs[name] = value;
            this.onAttrChange(name, value, originValue);
        }
    };
    /**
     * @protected
     * å±æ§å¼åçæ¹å
     * @param {string} name å±æ§å
     * @param {any} value å±æ§å¼
     * @param {any} originValue å±æ§å¼
     */
    Element.prototype.onAttrChange = function (name, value, originValue) {
        if (name === 'matrix') {
            this.set('totalMatrix', null);
        }
    };
    /**
     * å±æ§æ´æ¹åéè¦åçäºæ
     * @protected
     */
    Element.prototype.afterAttrsChange = function (targetAttrs) {
        if (this.cfg.isClipShape) {
            var applyTo = this.cfg.applyTo;
            if (applyTo) {
                applyTo.onCanvasChange('clip');
            }
        }
        else {
            this.onCanvasChange('attr');
        }
    };
    Element.prototype.show = function () {
        // ä¸æ¯é«é¢æä½ç´æ¥ä½¿ç¨ set
        this.set('visible', true);
        this.onCanvasChange('show');
        return this;
    };
    Element.prototype.hide = function () {
        // ä¸æ¯é«é¢æä½ç´æ¥ä½¿ç¨ set
        this.set('visible', false);
        this.onCanvasChange('hide');
        return this;
    };
    Element.prototype.setZIndex = function (zIndex) {
        this.set('zIndex', zIndex);
        var parent = this.getParent();
        if (parent) {
            // æ¹å zIndex ä¸åºè¯¥ç«å³è§¦åæ¸²æ (è°ç¨ onCanvasChange('zIndex'))ï¼éè¦ç»è¿ sort åè§¦å
            parent.sort();
        }
        return this;
    };
    Element.prototype.toFront = function () {
        var parent = this.getParent();
        if (!parent) {
            return;
        }
        var children = parent.getChildren();
        var el = this.get('el');
        var index = children.indexOf(this);
        children.splice(index, 1);
        children.push(this);
        this.onCanvasChange('zIndex');
    };
    Element.prototype.toBack = function () {
        var parent = this.getParent();
        if (!parent) {
            return;
        }
        var children = parent.getChildren();
        var el = this.get('el');
        var index = children.indexOf(this);
        children.splice(index, 1);
        children.unshift(this);
        this.onCanvasChange('zIndex');
    };
    Element.prototype.remove = function (destroy) {
        if (destroy === void 0) { destroy = true; }
        var parent = this.getParent();
        if (parent) {
            removeFromArray(parent.getChildren(), this);
            if (!parent.get('clearing')) {
                // å¦æç¶åç´ æ­£å¨æ¸çï¼å½ååç´ ä¸è§¦å remove
                this.onCanvasChange('remove');
            }
        }
        else {
            this.onCanvasChange('remove');
        }
        if (destroy) {
            this.destroy();
        }
    };
    Element.prototype.resetMatrix = function () {
        this.attr(MATRIX, this.getDefaultMatrix());
        this.onCanvasChange('matrix');
    };
    Element.prototype.getMatrix = function () {
        return this.attr(MATRIX);
    };
    Element.prototype.setMatrix = function (m) {
        this.attr(MATRIX, m);
        this.onCanvasChange('matrix');
    };
    // è·åæ»ç matrix
    Element.prototype.getTotalMatrix = function () {
        var totalMatrix = this.cfg.totalMatrix;
        if (!totalMatrix) {
            var currentMatrix = this.attr('matrix');
            var parentMatrix = this.cfg.parentMatrix;
            if (parentMatrix && currentMatrix) {
                totalMatrix = multiplyMatrix(parentMatrix, currentMatrix);
            }
            else {
                totalMatrix = currentMatrix || parentMatrix;
            }
            this.set('totalMatrix', totalMatrix);
        }
        return totalMatrix;
    };
    // ä¸å±åç»è®¾ç½® matrix
    Element.prototype.applyMatrix = function (matrix) {
        var currentMatrix = this.attr('matrix');
        var totalMatrix = null;
        if (matrix && currentMatrix) {
            totalMatrix = multiplyMatrix(matrix, currentMatrix);
        }
        else {
            totalMatrix = currentMatrix || matrix;
        }
        this.set('totalMatrix', totalMatrix);
        this.set('parentMatrix', matrix);
    };
    /**
     * @protected
     * è·åé»è®¤çç©éµ
     * @returns {number[]|null} é»è®¤çç©éµ
     */
    Element.prototype.getDefaultMatrix = function () {
        return null;
    };
    // å°åéåºç¨è®¾ç½®çç©éµ
    Element.prototype.applyToMatrix = function (v) {
        var matrix = this.attr('matrix');
        if (matrix) {
            return multiplyVec2(matrix, v);
        }
        return v;
    };
    // æ ¹æ®è®¾ç½®çç©éµï¼å°åéè½¬æ¢ç¸å¯¹äºå¾å½¢/åç»çä½ç½®
    Element.prototype.invertFromMatrix = function (v) {
        var matrix = this.attr('matrix');
        if (matrix) {
            var invertMatrix = invert(matrix);
            if (invertMatrix) {
                return multiplyVec2(invertMatrix, v);
            }
        }
        return v;
    };
    // è®¾ç½® clip
    Element.prototype.setClip = function (clipCfg) {
        var canvas = this.getCanvas();
        // åºè¯¥åªè®¾ç½®å½ååç´ ç clipï¼ä¸åºè¯¥å»ä¿®æ¹ clip æ¬èº«ï¼æ¹ä¾¿ clip è¢«å¤ç¨
        // TODO: setClip çä¼ åæ¢ shape éç½®ï¼ä¹æ¯æ shape å¯¹è±¡
        // const preShape = this.get('clipShape');
        // if (preShape) {
        //   // å°ä¹åç clipShape éæ¯
        //   preShape.destroy();
        // }
        var clipShape = null;
        // å¦æéç½®é¡¹ä¸º nullï¼åä¸ç§»é¤ clipShape
        if (clipCfg) {
            var ShapeBase = this.getShapeBase();
            var shapeType = upperFirst(clipCfg.type);
            var Cons = ShapeBase[shapeType];
            if (Cons) {
                clipShape = new Cons({
                    type: clipCfg.type,
                    isClipShape: true,
                    applyTo: this,
                    attrs: clipCfg.attrs,
                    canvas: canvas,
                });
            }
        }
        this.set('clipShape', clipShape);
        this.onCanvasChange('clip');
        return clipShape;
    };
    Element.prototype.getClip = function () {
        // é«é¢çè°ç¨çå°æ¹ç´æ¥ä½¿ç¨ this.cfg.xxx
        var clipShape = this.cfg.clipShape;
        // æªè®¾ç½®æ¶è¿å Nullï¼ä¿è¯ä¸è´æ§
        if (!clipShape) {
            return null;
        }
        return clipShape;
    };
    Element.prototype.clone = function () {
        var _this = this;
        var originAttrs = this.attrs;
        var attrs = {};
        each(originAttrs, function (i, k) {
            if (isArray(originAttrs[k])) {
                attrs[k] = _cloneArrayAttr(originAttrs[k]);
            }
            else {
                attrs[k] = originAttrs[k];
            }
        });
        var cons = this.constructor;
        // @ts-ignore
        var clone = new cons({ attrs: attrs });
        each(CLONE_CFGS, function (cfgName) {
            clone.set(cfgName, _this.get(cfgName));
        });
        return clone;
    };
    Element.prototype.destroy = function () {
        var destroyed = this.destroyed;
        if (destroyed) {
            return;
        }
        this.attrs = {};
        _super.prototype.destroy.call(this);
        // this.onCanvasChange('destroy');
    };
    /**
     * æ¯å¦å¤äºå¨ç»æåç¶æ
     * @return {boolean} æ¯å¦å¤äºå¨ç»æåç¶æ
     */
    Element.prototype.isAnimatePaused = function () {
        return this.get('_pause').isPaused;
    };
    /**
     * æ§è¡å¨ç»ï¼æ¯æå¤ç§å½æ°ç­¾å
     * 1. animate(toAttrs: ElementAttrs, duration: number, easing?: string, callback?: () => void, delay?: number)
     * 2. animate(onFrame: OnFrame, duration: number, easing?: string, callback?: () => void, delay?: number)
     * 3. animate(toAttrs: ElementAttrs, cfg: AnimateCfg)
     * 4. animate(onFrame: OnFrame, cfg: AnimateCfg)
     * åä¸ªåæ°çå«ä¹ä¸º:
     *   toAttrs  å¨ç»æç»ç¶æ
     *   onFrame  èªå®ä¹å¸§å¨ç»å½æ°
     *   duration å¨ç»æ§è¡æ¶é´
     *   easing   å¨ç»ç¼å¨ææ
     *   callback å¨ç»æ§è¡åçåè°
     *   delay    å¨ç»å»¶è¿æ¶é´
     */
    Element.prototype.animate = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (!this.get('timeline') && !this.get('canvas')) {
            return;
        }
        this.set('animating', true);
        var timeline = this.get('timeline');
        if (!timeline) {
            timeline = this.get('canvas').get('timeline');
            this.set('timeline', timeline);
        }
        var animations = this.get('animations') || [];
        // åå§å tick
        if (!timeline.timer) {
            timeline.initTimer();
        }
        var toAttrs = args[0], duration = args[1], _a = args[2], easing = _a === void 0 ? 'easeLinear' : _a, _b = args[3], callback = _b === void 0 ? noop : _b, _c = args[4], delay = _c === void 0 ? 0 : _c;
        var onFrame;
        var repeat;
        var pauseCallback;
        var resumeCallback;
        var animateCfg;
        // ç¬¬äºä¸ªåæ°ï¼æ¢å¯ä»¥æ¯å¨ç»æç»ç¶æ toAttrsï¼ä¹å¯ä»¥æ¯èªå®ä¹å¸§å¨ç»å½æ° onFrame
        if (isFunction(toAttrs)) {
            onFrame = toAttrs;
            toAttrs = {};
        }
        else if (isObject(toAttrs) && toAttrs.onFrame) {
            // å¼å®¹ 3.0 ä¸­çåæ³ï¼onFrame å repeat å¯å¨ toAttrs ä¸­è®¾ç½®
            onFrame = toAttrs.onFrame;
            repeat = toAttrs.repeat;
        }
        // ç¬¬äºä¸ªåæ°ï¼æ¢å¯ä»¥æ¯æ§è¡æ¶é´ durationï¼ä¹å¯ä»¥æ¯å¨ç»åæ° animateCfg
        if (isObject(duration)) {
            animateCfg = duration;
            duration = animateCfg.duration;
            easing = animateCfg.easing || 'easeLinear';
            delay = animateCfg.delay || 0;
            // animateCfg ä¸­çè®¾ç½®ä¼åçº§æ´é«
            repeat = animateCfg.repeat || repeat || false;
            callback = animateCfg.callback || noop;
            pauseCallback = animateCfg.pauseCallback || noop;
            resumeCallback = animateCfg.resumeCallback || noop;
        }
        else {
            // ç¬¬åä¸ªåæ°ï¼æ¢å¯ä»¥æ¯åè°å½æ° callbackï¼ä¹å¯ä»¥æ¯å»¶è¿æ¶é´ delay
            if (isNumber(callback)) {
                delay = callback;
                callback = null;
            }
            // ç¬¬ä¸ä¸ªåæ°ï¼æ¢å¯ä»¥æ¯ç¼å¨åæ° easingï¼ä¹å¯ä»¥æ¯åè°å½æ° callback
            if (isFunction(easing)) {
                callback = easing;
                easing = 'easeLinear';
            }
            else {
                easing = easing || 'easeLinear';
            }
        }
        var formatToAttrs = getFormatToAttrs(toAttrs, this);
        var animation = {
            fromAttrs: getFormatFromAttrs(formatToAttrs, this),
            toAttrs: formatToAttrs,
            duration: duration,
            easing: easing,
            repeat: repeat,
            callback: callback,
            pauseCallback: pauseCallback,
            resumeCallback: resumeCallback,
            delay: delay,
            startTime: timeline.getTime(),
            id: uniqueId(),
            onFrame: onFrame,
            pathFormatted: false,
        };
        // å¦æå¨ç»åç´ éåä¸­å·²ç»æè¿ä¸ªå¾å½¢äº
        if (animations.length > 0) {
            // åæ£æ¥æ¯å¦éè¦åå¹¶å±æ§ãè¥æç¸åçå¨ç»ï¼å°è¯¥å±æ§ä»åä¸ä¸ªå¨ç»ä¸­å é¤,ç´æ¥ç¨åä¸ä¸ªå¨ç»ä¸­
            animations = checkExistedAttrs(animations, animation);
        }
        else {
            // å¦åå°å¾å½¢æ·»å å°å¨ç»åç´ éå
            timeline.addAnimator(this);
        }
        animations.push(animation);
        this.set('animations', animations);
        this.set('_pause', { isPaused: false });
    };
    /**
     * åæ­¢å¨ç»
     * @param {boolean} toEnd æ¯å¦å°å¨ç»çæç»ç¶æ
     */
    Element.prototype.stopAnimate = function (toEnd) {
        var _this = this;
        if (toEnd === void 0) { toEnd = true; }
        var animations = this.get('animations');
        each(animations, function (animation) {
            // å°å¨ç»æ§è¡å°æåä¸å¸§
            if (toEnd) {
                if (animation.onFrame) {
                    _this.attr(animation.onFrame(1));
                }
                else {
                    _this.attr(animation.toAttrs);
                }
            }
            if (animation.callback) {
                // å¨ç»åæ­¢æ¶çåè°
                animation.callback();
            }
        });
        this.set('animating', false);
        this.set('animations', []);
    };
    /**
     * æåå¨ç»
     */
    Element.prototype.pauseAnimate = function () {
        var timeline = this.get('timeline');
        var animations = this.get('animations');
        var pauseTime = timeline.getTime();
        each(animations, function (animation) {
            animation._paused = true;
            animation._pauseTime = pauseTime;
            if (animation.pauseCallback) {
                // å¨ç»æåæ¶çåè°
                animation.pauseCallback();
            }
        });
        // è®°å½ä¸æ¯å¨ä»ä¹æ¶åæåç
        this.set('_pause', {
            isPaused: true,
            pauseTime: pauseTime,
        });
        return this;
    };
    /**
     * æ¢å¤å¨ç»
     */
    Element.prototype.resumeAnimate = function () {
        var timeline = this.get('timeline');
        var current = timeline.getTime();
        var animations = this.get('animations');
        var pauseTime = this.get('_pause').pauseTime;
        // ä¹åæ´æ°å±æ§éè¦è®¡ç®å¨ç»å·²ç»æ§è¡çæ¶é¿ï¼å¦ææåäºï¼å°±æåå§æ¶é´è°å
        each(animations, function (animation) {
            animation.startTime = animation.startTime + (current - pauseTime);
            animation._paused = false;
            animation._pauseTime = null;
            if (animation.resumeCallback) {
                animation.resumeCallback();
            }
        });
        this.set('_pause', {
            isPaused: false,
        });
        this.set('animations', animations);
        return this;
    };
    /**
     * è§¦åå§æäºä»¶
     * @param  {string}     type äºä»¶ç±»å
     * @param  {GraphEvent} eventObj äºä»¶å¯¹è±¡
     */
    Element.prototype.emitDelegation = function (type, eventObj) {
        var _this = this;
        var paths = eventObj.propagationPath;
        var events = this.getEvents();
        var relativeShape;
        if (type === 'mouseenter') {
            relativeShape = eventObj.fromShape;
        }
        else if (type === 'mouseleave') {
            relativeShape = eventObj.toShape;
        }
        var _loop_1 = function (i) {
            var element = paths[i];
            // æå®è· name ç»å®
            var name_1 = element.get('name');
            if (name_1) {
                // ç¬¬ä¸ä¸ª mouseenter å mouseleave çåæ­¢å³å¯ï¼å ä¸ºåé¢çé½æ¯åé¢ç Parent
                if (
                // åªæ element æ¯ Group æè Canvas çæ¶åï¼æéè¦å¤æ­ isParent
                (element.isGroup() || (element.isCanvas && element.isCanvas())) &&
                    relativeShape &&
                    isParent(element, relativeShape)) {
                    return "break";
                }
                if (isArray(name_1)) {
                    each(name_1, function (subName) {
                        _this.emitDelegateEvent(element, subName, eventObj);
                    });
                }
                else {
                    this_1.emitDelegateEvent(element, name_1, eventObj);
                }
            }
        };
        var this_1 = this;
        // è³å°æä¸ä¸ªå¯¹è±¡ï¼ä¸ç¬¬ä¸ä¸ªå¯¹è±¡ä¸º shape
        for (var i = 0; i < paths.length; i++) {
            var state_1 = _loop_1(i);
            if (state_1 === "break")
                break;
        }
    };
    Element.prototype.emitDelegateEvent = function (element, name, eventObj) {
        var events = this.getEvents();
        // äºä»¶å§æçå½¢å¼ name:type
        var eventName = name + DELEGATION_SPLIT + eventObj.type;
        if (events[eventName] || events[WILDCARD]) {
            // å¯¹äºééç¬¦ *ï¼äºä»¶åç§° = å§æäºä»¶åç§°
            eventObj.name = eventName;
            eventObj.currentTarget = element;
            eventObj.delegateTarget = this;
            // å°å§æäºä»¶ççå¬å¯¹è±¡ delegateObject æè½½å°äºä»¶å¯¹è±¡ä¸
            eventObj.delegateObject = element.get('delegateObject');
            this.emit(eventName, eventObj);
        }
    };
    /**
     * ç§»å¨åç´ 
     * @param {number} translateX æ°´å¹³ç§»å¨è·ç¦»
     * @param {number} translateY åç´ç§»å¨è·ç¦»
     * @return {IElement} åç´ 
     */
    Element.prototype.translate = function (translateX, translateY) {
        if (translateX === void 0) { translateX = 0; }
        if (translateY === void 0) { translateY = 0; }
        var matrix = this.getMatrix();
        var newMatrix = transform(matrix, [['t', translateX, translateY]]);
        this.setMatrix(newMatrix);
        return this;
    };
    /**
     * ç§»å¨åç´ å°ç®æ ä½ç½®
     * @param {number} targetX ç®æ ä½ç½®çæ°´å¹³åæ 
     * @param {number} targetX ç®æ ä½ç½®çåç´åæ 
     * @return {IElement} åç´ 
     */
    Element.prototype.move = function (targetX, targetY) {
        var x = this.attr('x') || 0;
        var y = this.attr('y') || 0;
        this.translate(targetX - x, targetY - y);
        return this;
    };
    /**
     * ç§»å¨åç´ å°ç®æ ä½ç½®ï¼ç­ä»·äº move æ¹æ³ãç±äº moveTo çè¯­ä¹æ§æ´å¼ºï¼å æ­¤å¨ææ¡£ä¸­æ¨èä½¿ç¨ moveTo æ¹æ³
     * @param {number} targetX ç®æ ä½ç½®ç x è½´åæ 
     * @param {number} targetY ç®æ ä½ç½®ç y è½´åæ 
     * @return {IElement} åç´ 
     */
    Element.prototype.moveTo = function (targetX, targetY) {
        return this.move(targetX, targetY);
    };
    /**
     * ç¼©æ¾åç´ 
     * @param {number} ratioX æ°´å¹³ç¼©æ¾æ¯ä¾
     * @param {number} ratioY åç´ç¼©æ¾æ¯ä¾
     * @return {IElement} åç´ 
     */
    Element.prototype.scale = function (ratioX, ratioY) {
        var matrix = this.getMatrix();
        var newMatrix = transform(matrix, [['s', ratioX, ratioY || ratioX]]);
        this.setMatrix(newMatrix);
        return this;
    };
    /**
     * ä»¥ç»å¸å·¦ä¸è§ (0, 0) ä¸ºä¸­å¿æè½¬åç´ 
     * @param {number} radian æè½¬è§åº¦(å¼§åº¦å¼)
     * @return {IElement} åç´ 
     */
    Element.prototype.rotate = function (radian) {
        var matrix = this.getMatrix();
        var newMatrix = transform(matrix, [['r', radian]]);
        this.setMatrix(newMatrix);
        return this;
    };
    /**
     * ä»¥èµ·å§ç¹ä¸ºä¸­å¿æè½¬åç´ 
     * @param {number} radian æè½¬è§åº¦(å¼§åº¦å¼)
     * @return {IElement} åç´ 
     */
    Element.prototype.rotateAtStart = function (rotate) {
        var _a = this.attr(), x = _a.x, y = _a.y;
        var matrix = this.getMatrix();
        var newMatrix = transform(matrix, [
            ['t', -x, -y],
            ['r', rotate],
            ['t', x, y],
        ]);
        this.setMatrix(newMatrix);
        return this;
    };
    /**
     * ä»¥ä»»æç¹ (x, y) ä¸ºä¸­å¿æè½¬åç´ 
     * @param {number} radian æè½¬è§åº¦(å¼§åº¦å¼)
     * @return {IElement} åç´ 
     */
    Element.prototype.rotateAtPoint = function (x, y, rotate) {
        var matrix = this.getMatrix();
        var newMatrix = transform(matrix, [
            ['t', -x, -y],
            ['r', rotate],
            ['t', x, y],
        ]);
        this.setMatrix(newMatrix);
        return this;
    };
    return Element;
}(Base));
export default Element;
//# sourceMappingURL=element.js.map